var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWww(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 13.4183 13.4183 17 9 17M17 9C17 4.58172 13.4183 1 9 1M17 9H1M9 17C4.58172 17 1 13.4183 1 9M9 17C6.94579 14.8431 5.8 11.9786 5.8 9C5.8 6.02139 6.94579 3.15692 9 1M9 17C11.0542 14.8431 12.2 11.9786 12.2 9C12.2 6.02139 11.0542 3.15692 9 1M1 9C1 4.58172 4.58172 1 9 1",
    stroke: "#121622",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWww);
export default __webpack_public_path__ + "static/media/icon_www.a827e3306b23a2c70d38e011f137c0d4.svg";
export { ForwardRef as ReactComponent };